<template>
<div>
	<el-row class="container">
		<el-col :span="24" class="header">
			{{collapsed?'':sysName}}
			<el-col :span="4" class="userinfo">
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner">{{sysUserName}}</span><span class="sanjiao"></span>
					<el-dropdown-menu slot="dropdown">
						<!-- <el-dropdown-item>我的消息</el-dropdown-item> -->
						<!-- <el-dropdown-item>设置</el-dropdown-item> -->
						<el-dropdown-item divided @click.native="changePassword">修改密码</el-dropdown-item>
						<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
						<el-dropdown-item divided @click.native="cancel">注销账号</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside :class="collapsed?'menu-collapsed':'menu-expanded'" v-if="isShowSideber">
				<!--导航菜单-->
				<!-- <el-menu :default-active="activeUrl" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect"
					 unique-opened router v-show="!collapsed">
					<template v-for="(item,index) in routesData"  v-if ="!item.hidden" >
						<el-submenu :index="index+''" v-if="!item.leaf" :key="index">
							<template slot="title"><i :class="item.iconCls"></i>{{item.NameZH}}</template>
							<el-menu-item v-for="child in item.children" :index="child.Path" :key="child.Path"
							>{{child.name}}</el-menu-item>
						</el-submenu>
						<el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].Path" :key="index"><i :class="item.iconCls"></i>{{item.children[0].name}}</el-menu-item>
					</template>
				</el-menu> -->

				<el-menu :default-active="activeUrl" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect"
					 unique-opened router v-show="!collapsed"  background-color="#F1F2F6"
				 >
					<template v-for="(item,index) in routesData">
						<!-- <el-submenu :index="String(index)" v-if="item.children && item.children.length > 0" :key="index">
							<template slot="title">{{item.NameZH}}</template>
							<el-menu-item v-for="child in item.children" :aabb="child.Url" :index="child.Url" :key="child.Url"
							>{{child.NameZH}}</el-menu-item>
						</el-submenu> -->
						<el-menu-item v-if="item.children && !item.children.length &&!item.ifhide" :aabb="item.Url"  :index="item.Url.toString()"  :rname="item.NameZH" :key="index" >
							<img :src="navImgSrc" alt="" style="width: 18px;margin-right: 6px;margin-top: -4px;" v-if="!item.ifShowClick">
							<img :src="navImgSrcClick" alt="" style="width: 18px;margin-right: 6px;margin-top: -4px;" v-if="item.ifShowClick">
							{{item.NameZH}}</el-menu-item>

					</template>
				</el-menu>

			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						<!-- <strong class="title">{{$route.name}}</strong> -->
						<!-- <el-breadcrumb separator="/" class="breadcrumb-inner">
							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
								{{ item.name }}
							</el-breadcrumb-item>
						</el-breadcrumb> -->
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>

	</el-row>
	<el-dialog title="修改密码" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="500px">
		<el-form :model="formData" ref="formData" :rules="formDataRules">
			<el-form-item class="change_formItem" label="请输入您现在的密码:" :label-width="formLabelWidth"  prop="OldPwd">
				<el-input v-model="formData.OldPwd" auto-complete="on" ref="password" :type="passwordType1" ></el-input>
				<span class="show-pwd" @click="showPwd">
					<svg-icon :icon-class="passwordType1 === 'password' ? 'eye' : 'eye-open'" />
				</span>
			</el-form-item>
			<el-form-item class="change_formItem" label="请设置新的密码:" :label-width="formLabelWidth"   prop="NewPwd">
				<el-input v-model="formData.NewPwd" autocomplete="off" :type="passwordType2"></el-input>
			</el-form-item>
			<el-form-item class="change_formItem" label="请再次输入新的密码:" :label-width="formLabelWidth"   prop="NewPwdAgin">
				<el-input v-model="formData.NewPwdAgin" autocomplete="off" :type="passwordType3"></el-input>
			</el-form-item>
			<div style="width: 180px;margin-left: 132px;margin-top: 28px;">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmPassWord('formData')">确 定</el-button>
			</div>
		</el-form>
	</el-dialog>

	<el-dialog title="注销账号" :visible.sync="dialogCancelVisible" :close-on-click-modal="false" width="580px">
		<div class="cancel_wrap">
			<div class="info"><i class="el-icon-warning"></i>确认注销账号？</div>
			<div class="tip">一旦注销成功，账号将<p>永久不可使用</p>且账号<p>信息将会被清空</p>，请谨慎操作。</div>
			<div class="btn">
				<el-button type="primary" class="confirm" @click="confirmCancel">确认注销</el-button>
				<el-button @click="dialogCancelVisible = false">取 消</el-button>
			</div>
		</div>
	</el-dialog>

	<el-dialog title="" :visible.sync="dialogHavedCancelVisible" width="580px" :close-on-click-modal="false"  @close="confirmHavedCancel">
		<div class="cancel_wrapped">
			<i class="el-icon-success"></i>
			<div class="tip">账号已注销</div>
		</div>
	</el-dialog>
</div>
</template>

<script>
	export default {
		data() {
			var validatePasswordAgin = (rule, value, callback) => {
				if(value==""){
					return callback(new Error('请输入确认密码'))
				}else if(value!==this.formData.NewPwd){
					return callback(new Error('两次密码输入不一致'))
				}
				else{
					callback();
				}
			}
			return {
				ifShowClick:false,
				navImgSrc:require("../assets/images/hui01.png"),
				navImgSrcClick:require("../assets/images/lan01.png"),
				sysName:'文献检测系统撤除比对申请平台',
				collapsed:false,
				sysUserName: '',
				sysUserAvatar: '',
				role:"",
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				activeIndex: "0",
				activeUrl: "",
				sidebarArr: [],
				isShowSideber: true,
				routerAlive:true,
				treeSidebarJson:{},
				routesData: [],
				dialogFormVisible:false,
				dialogCancelVisible: false,
				dialogHavedCancelVisible: false,
				formLabelWidth:'160px',
				formData:{
					OldPwd:"",
					NewPwd:"",
					NewPwdAgin:""
				},
				formDataRules:{
					OldPwd:[{required: true, message: '手机号不能为空', trigger: 'blur'}],
					//VCode:[{required: true, message: '验证码不能为空', trigger: 'blur'}],
					NewPwd:[{required: true, message: '密码不能为空', trigger: 'blur'}],
					NewPwdAgin:[{ required: true, trigger: 'blur', validator: validatePasswordAgin }]
				},
				passwordType:'password',
				passwordType1:'password',
				passwordType2:'password',
				passwordType3:'password'
			}
		},
		methods: {
			getMenuList(){//getMenuList
				// this.$api.getMenuList().then(res => {
				// 	console.log("res--menu",res.data);

				// });

			},
			changePassword(){//修改密码
				var _this = this;
				_this.dialogFormVisible = true;
			},
			onSubmit() {
				console.log('submit!');
			},
			handleopen() {
				//console.log('handleopen');
			},
			handleclose() {
				//console.log('handleclose');
			},
			handleselect: function (path, b) {
				var _this = this;
				_this.routesData.forEach(item =>{
					if(item.Path==path){
						item.ifShowClick=true;
					}else{
						item.ifShowClick=false;
					}
				})
			},
			//退出登录
			logout: function () {
				var _this = this;
				this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {
					_this.$api.Logout().then(res =>{
						if(res.data.result){
							sessionStorage.removeItem('userName');
							sessionStorage.removeItem('Authorization');
							sessionStorage.removeItem('Token');
							sessionStorage.removeItem('Role');
							_this.$router.push('/login');
						}else{
							this.$message({
								message: res.data.message,
								type: 'error',
								duration: 5 * 1000
							})
							_this.$router.push('/login');
						}
					})
				}).catch(() => {
				});
			},
			// 确认注销
			confirmCancel () {
				var _this = this;
				// _this.dialogHavedCancelVisible = true
				_this.$api.CancelUser().then(res =>{
					if(res.data.result){
						_this.dialogHavedCancelVisible = true
						sessionStorage.removeItem('userName');
						sessionStorage.removeItem('Authorization');
						sessionStorage.removeItem('Token');
						sessionStorage.removeItem('Role');
					}else{
						this.$message({
							message: res.data.message,
							type: 'error',
							duration: 5 * 1000
						})
					}
				})
			},
			confirmHavedCancel () {
				var _this = this;
				_this.$router.push('/login');
			},
			showPwd() {
				if (this.passwordType1 === 'password') {
					this.passwordType1 = ''
				} else {
					this.passwordType1 = 'password'
				}
				this.$nextTick(() => {
					this.$refs.password.focus()
				})
			},

			// 注销账号
			cancel: function () {
				var _this = this;
				_this.dialogCancelVisible = true;
			},
			//折叠导航栏
			collapse:function(){
				this.collapsed=!this.collapsed;
			},
			showMenu(i,status){
				this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
			},
			getTreeSidebarJson(){
            var _this = this;
            _this.routesData.forEach(function(item, index) {
              _this.treeSidebarJson[item.Url] = [];
              _this.treeSidebarJson[item.Url].push({
				url: item.Url,
				path:item.Path,
				name: item.NameZH,
				iconCls:item.IconCls
			  })
              recursion(item.children,item.Url)
            })
            function recursion(arr,url){
              arr.forEach(function(item){
                if(item.children){
                  recursion(item.children,url)
                }
                _this.treeSidebarJson[url].push(item)
              })
            }
          },
		getActiveIndex(path){
			// debugger;
			var _this = this;
			var index = 0;
			var treeSidebarJson = _this.treeSidebarJson;
			_this.isShowSideber = true
			_this.routesData.forEach(item =>{
				// debugger
				if(item.Path==path){
					item.ifShowClick=true;
				}else{
					item.ifShowClick=false;
				}
			})
			for(var key in treeSidebarJson){
				treeSidebarJson[key].forEach(function(item){
					if(path == item.path){
					_this.activeIndex = index.toString();
					_this.activeUrl = item.path;
					}
				})
			index++;
			}
		},
		confirmPassWord(formData){
			 this.$refs.formData.validate(valid => {
				 if(valid){
					var _this = this;
					_this.$api.ChangePwd(_this.formData).then( res =>{
						// console.log("changePaw=========",res);
						if(res.data.result){
						this.$message({
							message: "密码修改成功,下次登录请使用新密码",
							type: 'success',
							duration: 5 * 1000
						})
						_this.dialogFormVisible =false;
						}else{
						this.$message({
							message: res.data.message,
							type: 'error',
							duration: 5 * 1000
						})
						}
					})
				 }
			 })

		},
		},
		mounted() {
			this.sysUserName =sessionStorage.getItem("userName");
			// debugger
			// console.log("ssssss-----",this.$router.options.routes)
			// console.log("role=========",sessionStorage.getItem("Role"))
			var role = sessionStorage.getItem("Role")
			if(role == "requester"){
				this.routesData=[{
					"ID":1 ,
					"Url": "/applyIndex",
					"Path": "/applyIndex",
					"Component": "",
					"NameZH": "提交申请",
					"IconCls": "el-icon-location",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false,
					"ifhide":false
				},
				{
					"ID":2 ,
					"Url": "/applyRecord",
					"Path": "/applyRecord",
					"Component": "",
					"NameZH": "申请记录",
					"IconCls": "",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false,
					"ifhide":false
				},
				{
					"ID":3,
					"Url": '/viewRecord/:id/:pageType',
					"Path": "/applyRecord",
					"Component": "",
					"NameZH": "viewRecord",
					"IconCls": "",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false,
					"ifhide":true
				}
				]
			}else if(role == "reviewer"){//审核人
				this.routesData=[{
					"ID":1 ,
					"Url": "/waitVerify",
					"Path": "/waitVerify",
					"Component": "",
					"NameZH": "待审核列表",
					"IconCls": "el-icon-location",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false
				},
				{
					"ID":2 ,
					"Url": "/checkedList",
					"Path": "/checkedList",
					"Component": "",
					"NameZH": "已审核列表",
					"IconCls": "",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false
				},
				 {
					"ID": 3,
					"Url": "/manageUser",
					"Path": "/manageUser",
					"Component": "",
					"NameZH": "用户账号管理",
					"IconCls": "",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false
				},
				{
					"ID": 4,
					"Url": "/dataBase",
					"Path": "/dataBase",
					"Component": "",
					"NameZH": "数据库",
					"IconCls": "",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false
				},
				{
					"ID": 5,
					"Url": "/userLog",
					"Path": "/userLog",
					"Component": "",
					"NameZH": "用户操作日志",
					"IconCls": "",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false
				},
				{
					"ID": 6,
					"Url": "/infoCount",
					"Path": "/infoCount",
					"Component": "",
					"NameZH": "信息统计",
					"IconCls": "",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false
				},
				]
			}else if(role == "executer"){//撤除执行人
				this.routesData=[
				{
					"ID": 1,
					"Url": "/cancelInfo",
					"Path": "/cancelInfo",
					"Component": "",
					"NameZH": "待处理列表",
					"IconCls": "",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false
				},
				 {
					"ID": 2,
					"Url": "/manageUser",
					"Path": "/manageUser",
					"Component": "",
					"NameZH": "用户账号管理",
					"IconCls": "",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false
				},

				{
					"ID": 3,
					"Url": "/userLog",
					"Path": "/userLog",
					"Component": "",
					"NameZH": "用户操作日志",
					"IconCls": "",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false
				},
				{
					"ID": 4,
					"Url": "/dataBase",
					"Path": "/dataBase",
					"Component": "",
					"NameZH": "数据库",
					"IconCls": "",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false
				},
				{
					"ID": 5,
					"Url": "/infoCount",
					"Path": "/infoCount",
					"Component": "",
					"NameZH": "信息统计",
					"IconCls": "",
					"KeepAlive": 1,
					"RequireAuth": 1,
					"ParentID": 1,
					children: [],
					"ChildMenus": null,
					"ifShowClick":false

				},

				]
			}

			var _this = this;
			var path = _this.$route.meta && _this.$route.meta.activeMenu || _this.$route.path; // 如果有 meta.activeMenu 就判断 meta.activeMenu   否则判断 path
			// debugger;
			// console.log("path====",path)
			_this.routesData.forEach(item =>{
				// debugger
				if(item.Path==path){
					item.ifShowClick=true;
				}else{
					item.ifShowClick=false;
				}
			})
			_this.getTreeSidebarJson();
			_this.getActiveIndex(path);

		},
		created() {

		},
		watch: {
			$route(to, from) {
			var _this = this;
			var path = to.path;
			_this.getActiveIndex(path);
			//document.getElementsByClassName("el-main")[0].scrollTop = 0;
			}
		},
	}

</script>

<style scoped lang="scss">
	@import '../styles/vars';

	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			background: #ffffff;
			border-bottom: 5px solid $color-primary;
			background: $color-primary;
			color:#fff;
			font-size: 20px;
			font-weight: bold;
			padding-left: 20px;
			.userinfo {
				text-align: right;
				padding-right: 35px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color:#FFF;
					border-bottom:1px solid #fff;

					img {
						width: 40px;
						height: 40px;
						border-radius: 20px;
						margin: 10px 0px 10px 10px;
						float: right;
					}
				}
				.sanjiao{
						display: inline-block;
						width:0;
						height:0;
						border-right:7px solid transparent;
						border-left:7px solid transparent;
						border-top:10px solid #fff;
						margin-left:3px;
					}
			}
			.logo {
				//width:230px;
				height:160px;
				font-size: 22px;
				padding-left:20px;
				padding-right:20px;
				border-color: #f0f0f0;
				border-right-width: 1px;
				border-right-style: solid;
				// background: url("http://img4.duitang.com/uploads/item/201511/26/20151126112617_vUaQf.jpeg") no-repeat center;
				background-size: 60%;
				background-color: #ffffff;
				img {
					width: 40px;
					float: left;
					margin: 10px 10px 10px 18px;
				}
				.txt {
					color:#fff;
				}
			}
			.logo-width{
				width:230px;
			}
			.logo-collapse-width{
				width:60px
			}
			.tools{
				padding: 0px 23px;
				width:14px;
				height: 60px;
				line-height: 60px;
				cursor: pointer;
			}
		}
		.main {
			display: flex;
			// background: #324057;
			position: absolute;
			top: 60px;
			bottom: 0px;
			overflow: hidden;;
			aside {
				flex:0 0 230px;
				width: 230px;
				// position: absolute;
				// top: 0px;
				// bottom: 0px;
				.el-menu{
					height: 100%;
				}
				.collapsed{
					width:60px;
					.item{
						position: relative;
					}
					.submenu{
						position:absolute;
						top:0px;
						left:60px;
						z-index:99999;
						height:auto;
						display:none;
					}

				}
			}
			.menu-collapsed{
				flex:0 0 60px;
				width: 60px;
			}
			.menu-expanded{
				flex:0 0 230px;
				width: 230px;
				// padding-top: 100px;
			}
			.content-container {
				// background: #f1f2f7;
				flex:1;
				// position: absolute;
				// right: 0px;
				// top: 0px;
				// bottom: 0px;
				// left: 230px;
				overflow: auto;
				padding: 20px;
				//padding-left:0px;
				.breadcrumb-container {
					//margin-bottom: 15px;
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}
			}
		}
	}
	.el-menu-item.is-active{
		 background: #C9D1E4!important;
		color:#2850A7;
	}
	 .el-menu-item:hover{
		background-color: #ecf5ff!important;
		font-weight: bold;
	}
	.change_formItem{
		margin-bottom:14px;
	}
	.show-pwd {
		position: absolute;
		right: 10px;
		top: 7px;
		font-size: 16px;
		color: #889aa4;
		cursor: pointer;
		user-select: none;
	}
	.cancel_wrap {
		text-align: center;
		font-size: 16px;
		.info {
			margin-bottom: 20px;
			display: flex;
			justify-content: center;
			align-items: center;
			i {
				color: #e32f2f;
				font-size: 30px;
				margin-right: 6px;
			}
		}
		.tip {
			display: flex;
			p {
				font-weight: bold;
			}
		}
		.btn {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 30px;
			.confirm {
				background-color: #e32f2f;
				color: #fff;
				border: none;
				:hover {
					background-color: #e32f2f;
					color: #fff;
				}
			}
		}
		
	}
	.cancel_wrapped {
		text-align: center;
		font-size: 20px;
		i {
			color: green;
			font-size: 32px;
			margin-bottom: 40px;
		}
		.tip {
			margin-bottom: 30px;
		}
	}
</style>



// WEBPACK FOOTER //
// Home.vue?61ea47c5